import React from 'react';
import { useConfig } from './config';

const PrivacyPolicy = () => {
  const config = useConfig();
  const lastUpdated = "November 14, 2024";

  return (
    <main>
      <div className="max-w-3xl mx-auto px-4 py-6 sm:px-6 lg:px-8 bg-white rounded-lg shadow-xl my-8 relative">
        {/* Decorative elements */}
        <div className="absolute top-0 right-0 w-40 h-40 bg-blue-500 rounded-full filter blur-3xl opacity-5 -translate-y-1/2 translate-x-1/2"></div>
        <div className="absolute bottom-0 left-0 w-40 h-40 bg-red-500 rounded-full filter blur-3xl opacity-5 translate-y-1/2 -translate-x-1/2"></div>
        
        {/* Content */}
        <h1 className="text-3xl font-bold text-gray-900 mb-4 relative inline-block">
          Privacy Policy
          <span className="absolute -bottom-1 left-0 right-0 h-1 bg-gradient-to-r from-red-500 to-blue-500 rounded-full"></span>
        </h1>
        
        <p className="text-sm text-gray-600 mb-6">
          <strong>Last updated:</strong> {lastUpdated}
        </p>

        <p className="mb-4 text-gray-700">
          At <strong>{config.siteName}</strong> (hereinafter referred to as "we", "us", or "the website"), we respect and protect the privacy of our users and are committed to safeguarding the personal data you share with us. This Privacy Policy explains how we collect, use, store, and protect personal data.
        </p>

        <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4 relative inline-block">
          1. Information We Collect
          <span className="absolute -bottom-1 left-0 right-0 h-px bg-gradient-to-r from-red-400 to-blue-400 rounded-full"></span>
        </h2>
        
        <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-2">1.1 Personal Data</h3>
        <p className="mb-4 text-gray-700">
          We may collect personal data that you voluntarily provide through registration forms, newsletter sign-ups, contact forms, and other methods. This data may include:
        </p>
        <ul className="list-disc list-inside mb-4 text-gray-700">
          <li>First and last name</li>
          <li>Email address</li>
          <li>Phone number</li>
          <li>Mailing address</li>
          <li>Payment information (if relevant for purchasing products or services)</li>
          <li>Any other information you provide to us</li>
        </ul>

        <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-2">1.2 Usage and Advertising Data</h3>
        <p className="mb-4 text-gray-700">
          We use tools like Google Ads and Google Analytics to collect information about how you interact with our website. This information may include:
        </p>
        <ul className="list-disc list-inside mb-4 text-gray-700">
          <li>IP address</li>
          <li>Browser type and version</li>
          <li>Pages visited</li>
          <li>Date and time of visit</li>
          <li>Time spent on pages</li>
          <li>Clicks on ads and conversions</li>
          <li>Other statistical data</li>
        </ul>

        <p className="mb-4 text-gray-700">
          For more information about how Google uses collected data, please refer to the <a href="https://policies.google.com/technologies/ads" className="text-blue-600 hover:text-blue-800 relative group">
            Google Privacy Policy
            <span className="absolute bottom-0 left-0 w-full h-0.5 bg-blue-400 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300"></span>
          </a>.
        </p>

        <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4 relative inline-block">
          2. Consent and Privacy Options
          <span className="absolute -bottom-1 left-0 right-0 h-px bg-gradient-to-r from-red-400 to-blue-400 rounded-full"></span>
        </h2>
        <p className="mb-4 text-gray-700">
          When visiting our website, you will be asked to consent or decline the use of cookies and data collection for advertising purposes. You can change your preferences at any time in the cookie settings on our website.
        </p>

        <p className="mb-4 text-gray-700">
          You can also opt out of personalized advertising from Google at:
          <a href="https://adssettings.google.com/authenticated" className="text-blue-600 hover:text-blue-800 ml-1 relative group">
            Google Ad Settings
            <span className="absolute bottom-0 left-0 w-full h-0.5 bg-blue-400 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300"></span>
          </a>.
        </p>

        <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4 relative inline-block">
          3. Children's Privacy
          <span className="absolute -bottom-1 left-0 right-0 h-px bg-gradient-to-r from-red-400 to-blue-400 rounded-full"></span>
        </h2>
        <p className="mb-4 text-gray-700">
          Our website is not intended for children under the age of 16 without parental or guardian supervision. We do not knowingly collect personal data from children under this age. If you are a parent or guardian and believe your child has provided us with personal data, please contact us so we can delete this information.
        </p>

        <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4 relative inline-block">
          4. Changes to This Privacy Policy
          <span className="absolute -bottom-1 left-0 right-0 h-px bg-gradient-to-r from-red-400 to-blue-400 rounded-full"></span>
        </h2>
        <p className="mb-4 text-gray-700">
          We reserve the right to update this Privacy Policy at any time to reflect changes in our practices. Users are encouraged to review this page regularly.
        </p>
      </div>
    </main>
  );
};

export default PrivacyPolicy;